"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6],{

/***/ 66565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CheckboxSVG = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.55491 13.1098C10.1751 13.1098 13.1098 10.1751 13.1098 6.55491C13.1098 2.93474 10.1751 0 6.55491 0C2.93474 0 0 2.93474 0 6.55491C0 10.1751 2.93474 13.1098 6.55491 13.1098ZM9.86117 5.0764C10.0949 4.76985 10.0358 4.33187 9.72927 4.09817C9.42271 3.86446 8.98474 3.92352 8.75103 4.23008L6.16635 7.62044L4.90602 6.10805C4.65924 5.81192 4.21912 5.7719 3.92299 6.01868C3.62685 6.26546 3.58684 6.70558 3.83362 7.00172L6.21491 9.85927L9.86117 5.0764Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxSVG);


/***/ }),

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// UNUSED EXPORTS: productIdToCluster

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var _obj1;
var productIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var ProductSignUp = function(_param) {
    var displayImage = _param.displayImage, useCtaText = _param.useCtaText, buttonSize = _param.buttonSize, withButtonArrow = _param.withButtonArrow, ctaText = _param.ctaText, _productType = _param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = _param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = _param.signupClusterId, useCtaIcon = _param.useCtaIcon, _buttonColor = _param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = _param.invert, beforeSubmitCallback = _param.beforeSubmitCallback, excludeFromWMHighIntentExperienceTest = _param.excludeFromWMHighIntentExperienceTest, extraData = _param.extraData, restOfConfig = _object_without_properties(_param, [
        "displayImage",
        "useCtaText",
        "buttonSize",
        "withButtonArrow",
        "ctaText",
        "productType",
        "selectedProductIds",
        "signupClusterId",
        "useCtaIcon",
        "buttonColor",
        "invert",
        "beforeSubmitCallback",
        "excludeFromWMHighIntentExperienceTest",
        "extraData"
    ]);
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = productIdToCluster[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({}, restOfConfig), {
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    updateClusters();
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: _object_spread({
                    selectedProduct: productType
                }, extraData || {}),
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            }))
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 80006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product_cards_side_by_side_text_and_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-title/product-card-title.scss.js

var StyledProductCardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euzknt40"
})("display:flex;gap:16px;.main-title{font-size:1.25rem;font-weight:600;line-height:normal;}.picture-component{img{width:50px;object-fit:contain;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-title/product-card-title.js






var ProductCardTitle = function(param) {
    var color = param.color, productImage = param.productImage, body = param.body, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardTitle, {
        className: "product-card-title",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: productImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-title-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                        titleColor: color,
                        titleClassName: "main-title",
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        bodyColor: "asphalt",
                        body: body,
                        textSize: sizes.XS
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_card_title = (ProductCardTitle);

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-content/product-card-content.scss.js

var BORDER_COLOR = "#d9d9d9";
var StyledProductCardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efg8nn70"
})("display:flex;flex-direction:column;.content-title{font-size:2rem;line-height:2.375rem;font-weight:600;}.use-cases-wrapper{padding-top:12px;border-top:0.5px solid;border-color:", BORDER_COLOR, ";}");

// EXTERNAL MODULE: ./segments/desktop/core-components/product-card/checkbox-icon.js
var checkbox_icon = __webpack_require__(66565);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-content/product-card-use-cases/product-card-use-cases.scss.js




var StyledProductCardUseCases = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efgzmey0"
})("@media (min-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){.signup-button{height:40px;font-size:0.875px;}}.readonly-use-cases-wrapper{display:flex;gap:12px;flex-wrap:wrap;margin-bottom:32px;margin-top:24px;.readonly-use-case{display:flex;align-items:center;gap:8px;&.work-management{svg{width:20px;height:20px;path{fill:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}}}}.selectable-tags-grid{.selectable-tags-button-container{justify-content:flex-start;}.selectable-tags-container-wrapper{display:flex;gap:12px;flex-wrap:wrap;margin-bottom:32px;margin-top:24px;justify-content:flex-start;.selectable-tag-wrapper{border:1px solid ", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";margin:0;background-color:transparent;padding:4px 8px;&:hover{border-color:var(--color);}&.selected{border-color:var(--color);.selectable-tag-image-container{color:var(--color);}}.selectable-tag-image-container{height:12px;width:12px;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";svg{width:8px;height:6px;}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid.js + 1 modules
var selectable_tags_grid = __webpack_require__(94222);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-content/product-card-use-cases/product-card-use-cases.js
function product_card_use_cases_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_card_use_cases_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ProductCardUseCases = function(param) {
    var useCases = param.useCases, productColor = param.productColor, isUseCasesReadonly = param.isUseCasesReadonly, productType = param.productType, showUseCasesVertically = param.showUseCasesVertically;
    var buttonConfig = (0,react.useMemo)(function() {
        return {
            useCtaIcon: true,
            buttonSize: sizes.XS,
            buttonColor: productColor,
            productIdToUse: productType,
            skipUpdateCluster: true,
            extraData: {
                selectedProduct: productType
            }
        };
    }, [
        productColor,
        productType
    ]);
    var gridSelectableTags = (0,react.useMemo)(function() {
        return useCases === null || useCases === void 0 ? void 0 : useCases.map(function(_param) {
            var useCase = _param.useCase, rest = _object_without_properties(_param, [
                "useCase"
            ]);
            return _object_spread({
                tagText: useCase
            }, rest);
        });
    }, [
        useCases
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardUseCases, {
        className: "product-card-use-cases",
        style: {
            "--color": colors/* default */.Z[productColor]
        },
        children: [
            isUseCasesReadonly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "readonly-use-cases-wrapper",
                style: {
                    flexDirection: showUseCasesVertically ? "column" : "row"
                },
                children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function(param, index) {
                    var useCase = param.useCase;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("readonly-use-case", {
                            "work-management": productType === products/* WORK_MANAGEMENT_PRODUCT_ID */.py
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                            useCase
                        ]
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tags_grid/* default */.Z, {
                buttonTopMargin: "0",
                disableAnimation: true,
                buttonConfig: buttonConfig,
                gridSelectableTags: gridSelectableTags
            }),
            isUseCasesReadonly && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, {
                useCtaIcon: true,
                buttonSize: sizes.XS,
                buttonColor: productColor,
                productType: productType
            })
        ]
    });
};
/* harmony default export */ var product_card_use_cases = (ProductCardUseCases);

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-content/product-card-content.js





var ProductCardContent = function(param) {
    var title = param.title, body = param.body, titleWidth = param.titleWidth, useCasesWidth = param.useCasesWidth, useCases = param.useCases, textWidth = param.textWidth, productColor = param.productColor, isUseCasesReadonly = param.isUseCasesReadonly, productType = param.productType, showUseCasesVertically = param.showUseCasesVertically, spaceUnderTitle = param.spaceUnderTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardContent, {
        className: "product-card-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-container",
                style: {
                    marginBottom: spaceUnderTitle,
                    maxWidth: titleWidth
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                    title: title,
                    titleClassName: "content-title"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "use-cases-wrapper",
                style: {
                    maxWidth: useCasesWidth
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        textWidth: textWidth,
                        body: body
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_use_cases, {
                        productColor: productColor,
                        productType: productType,
                        useCases: useCases,
                        isUseCasesReadonly: isUseCasesReadonly,
                        showUseCasesVertically: showUseCasesVertically
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_card_content = (ProductCardContent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-features/product-card-features.scss.js



var StyledProductCardFeatures = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezutwb0"
})("display:flex;flex-direction:column;gap:20px;font-size:0.875rem;padding-right:72px;.divider{width:100%;padding:0 60px;height:1px;background-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}.features{display:flex;align-items:center;gap:16px;.feature{display:flex;gap:8px;align-items:center;svg{width:12px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card-features/product-card-features.js



var ProductCardFeatures = function(param) {
    var features = param.features;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardFeatures, {
        className: "product-card-features",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "features",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Popular features:"
                    }),
                    features === null || features === void 0 ? void 0 : features.map(function(param) {
                        var feature = param.feature;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "feature",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                                feature
                            ]
                        });
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_card_features = (ProductCardFeatures);

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card.scss.js




var StyledProductCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqwqlkk0"
})("width:100%;display:flex;flex-direction:column;gap:50px;margin:0;border-radius:12px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";padding:72px 0 32px 48px;box-shadow:0 8px 24px 0 rgba(0,0,0,0.1);.product-image{.picture-component{display:flex;img{max-width:100%;object-fit:contain;max-height:100%;border-bottom-right-radius:12px;border-bottom-left-radius:12px;}}}.card-top{display:flex;gap:100px;justify-content:space-between;.product-details{display:flex;min-width:fit-content;flex-direction:column;gap:32px;@media (max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px){min-width:40%;}}}&.condensed-card{padding-top:40px;padding-bottom:0;padding-left:0;.product-image{display:flex;justify-content:center;img{width:100%;object-fit:contain;}}.card-top{display:flex;gap:40px;flex-direction:column;justify-content:space-between;.product-details{padding:0 40px 0 40px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/product-card.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_card_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function product_card_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = product_card_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function product_card_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













var _obj;
var PRODUCT_TO_COLORS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.WORK_OS_IRIS_COLOR_NAME), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), _obj);
var ProductCard = function(param) {
    var _productType = param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, cardTitle = param.cardTitle, cardBackgroundColor = param.cardBackgroundColor, cardTitleConfig = param.cardTitleConfig, cardContent = param.cardContent, cardAsset = param.cardAsset, isCondensed = param.isCondensed, showUseCasesVertically = param.showUseCasesVertically;
    var _ref = cardContent || {}, features = _ref.features, cardPaddingTop = _ref.cardPaddingTop, cardPaddingBottom = _ref.cardPaddingBottom, restOfCardContent = product_card_object_without_properties(_ref, [
        "features",
        "cardPaddingTop",
        "cardPaddingBottom"
    ]);
    var cardStyle = (0,react.useMemo)(function() {
        return {
            backgroundColor: colors/* default */.Z[cardBackgroundColor],
            color: (0,segments_service/* isDarkTheme */.$o)(cardBackgroundColor) ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR],
            paddingTop: cardPaddingTop,
            paddingBottom: cardPaddingBottom
        };
    }, [
        cardBackgroundColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCard, {
        className: classnames_default()("product-card-component", {
            "condensed-card": isCondensed
        }),
        style: cardStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-details",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_title, _object_spread_props(product_card_object_spread({}, cardTitle), {
                                titleConfig: cardTitleConfig,
                                color: PRODUCT_TO_COLORS[productType]
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_content, product_card_object_spread({
                                productType: productType,
                                productColor: PRODUCT_TO_COLORS[productType],
                                showUseCasesVertically: showUseCasesVertically
                            }, restOfCardContent))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: cardAsset
                        })
                    })
                ]
            }),
            (features === null || features === void 0 ? void 0 : features.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_features, {
                features: features
            })
        ]
    });
};
/* harmony default export */ var product_card = (ProductCard);
ProductCard.defaultProps = default_props;

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-component.scss.js



var HEADER_LOGO_HORIZONTAL_PADDING = constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING;
var StyledProductCardsSideBySideTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s09ils0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0 ", HEADER_LOGO_HORIZONTAL_PADDING, "px;display:flex;gap:48px;padding-top:60px;.product-card-component{flex:1;}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){gap:36px;.product-card-component{.card-top .product-details{.product-card-title .card-title-text{display:flex;flex-direction:column;justify-content:center;.main-title{font-size:1rem;line-height:20px;}}.product-card-content .content-title{font-size:1.75rem;line-height:36px;}.product-card-content .use-cases-wrapper{.product-card-use-cases .readonly-use-cases-wrapper{max-width:400px;.paragraph-wrapper .paragraph-body{font-size:1rem;}}}}&.condensed-card{.card-top .product-details{@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){.product-card-content{.paragraph-wrapper .paragraph-body{font-size:1rem;}.content-title{min-height:110px;}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-component.js
function product_cards_side_by_side_text_and_asset_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_side_by_side_text_and_asset_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_side_by_side_text_and_asset_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



var ProductCardsSideBySideTextAndAssetComponent = function(param) {
    var cards = param.cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCardsSideBySideTextAndAssetComponent, {
        className: "product-cards-side-by-side-text-and-asset-component",
        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card, product_cards_side_by_side_text_and_asset_component_object_spread({
                isCondensed: cards.length > 1
            }, card), index);
        })
    });
};
/* harmony default export */ var product_cards_side_by_side_text_and_asset_component = (ProductCardsSideBySideTextAndAssetComponent);


/***/ })

}]);